import * as React from 'react';
import parse from 'html-react-parser';

import { Dictionary, Props } from '../types/types';

import { Container, Row, Col } from 'react-bootstrap';
import { View, Text, rem, IconButton } from '../libs/WebComponents';
import ButtonReadMore from '../Components/ButtonReadMore';
import IconButtonShadow from '../Components/IconButtonShadow';
import AppTip from '../Pages/AppTip';
import {nl2br} from '../utils/utils-app';
import { usePopupStore } from '../store/popups';
import { wpAuthGET, wpAuthPOST } from '../api/api-user';
import { HandleFetchError } from '../api/api-root';
import { QuestionType, useQuestionStore } from '../store/questions';
import { add_action, do_actions, remove_action } from '../utils/FiltersAndActions';
import { WpPage } from '../App';
import { useUserStore } from '../store/user';
import {useGrowlStore} from '../store/growls';
import PhotoUploader from '../Components/PhotoUploader';

import QuestionAB from '../Questions/QuestionAB';
import QuestionABC from '../Questions/QuestionABC';
import QuestionOpen from '../Questions/QuestionOpen';
import QuestionLocation from '../Questions/QuestionLocation';
import QuestionSwipe from '../Questions/QuestionSwipe';
import QuestionRange from '../Questions/QuestionRange';
import { parsePostContent } from './parsePage';

const AppQuestion = (props: Props) => {

   const { group_id} = useUserStore();
   const { addPopup, removePopup } = usePopupStore();
   const {addGrowl} = useGrowlStore();
   const [answersContainer, setAnswersContainer] = React.useState<Dictionary>();
   const {questions, upsertQuestion} = useQuestionStore();
   const [photos, setPhotos] = React.useState<string[]>([]);
   const [uploads, setUploads] = React.useState<number>(0);
   const [givenAnswers, setGivenAnswers] = React.useState<QuestionType>();

   const _showReadMore = (props: Props) => {
      if (props.read_more) {
         const uuid = addPopup({type:'fullscreen question', children: <View className={'popup-content'}>{parsePostContent({removePopup:()=>removePopup(uuid),content:props.read_more, firstname:props.firstname, goTo:props.goTo, index:props.index})}</View>});
      }
   };

   const _addMedia = () => {
      const uuid = addPopup({type:'photoupload', children: <PhotoUploader group_id={group_id} page={props.page} onClose={()=>removePopup(uuid)} uploadDone={_uploadDone}/>});
   };

   const _uploadDone = (photo: string) => {
      setPhotos(phs =>[...phs, photo]);
   };

   const _showTip = React.useCallback(async(slug: string)=>{
      do_actions('startLoadingTip');
      try{
         const results: {content: string, question_type: string} = await wpAuthGET('tips/' + slug, {group_id: props.group.ID});
         if (results)
         {
            const content: string = results.content;
            const uuid = addPopup({type:'tip', children: <AppTip body={content} onClose={()=>removePopup(uuid)} />});
         }
         do_actions('stopLoadingTip', {error: false});

      }catch(err: HandleFetchError | any)
      {
         console.warn(err);
         addGrowl({ message:'Er is iets misgegaan bij het ophalen van de toelichting', type:'danger', dismissible:true,autoclose:5000});

         do_actions('stopLoadingTip', {error: true});
      }   
   },[props.group]);


   const _submitAnswers = React.useCallback(async(page: WpPage, answers: any, uploads: number) => {
   
      upsertQuestion({type: page.question_type, id: page.ID, ...answers, uploads: uploads});
      try{
         const results: any | {success: boolean} = await wpAuthPOST('user/question', {group_id, question_id: page.ID, answers: {...answers}, uploads: uploads});
         if (results && !results.success)
         {
            throw(results);
            //removeUser();
         }
      }catch(err: HandleFetchError | any)
      {
         console.warn(err);
         addGrowl({type:'danger', message:'Fout bij opslag van antwoorden', dismissible:true});
      }
   },[]);

   React.useEffect(()=>{
      
      const given_answers = questions.find((q: QuestionType)=>q.id === props.page.ID);
      
      let all_uploads = given_answers && given_answers.uploads?given_answers.uploads:0;
      all_uploads = all_uploads + photos.length;

      const action = add_action('submitAnswers', ()=>answersContainer && _submitAnswers(props.page, answersContainer, all_uploads));
      setGivenAnswers(given_answers);
      setUploads(all_uploads);

      return ()=>{
         remove_action('submitAnswers', action);
      }
   },[props.page, answersContainer, photos]);

   let QuestionView =<View style={{paddingTop:rem(3)}}><Text style={{fontWeight:'bold', color:'var(--color-danger)'}}>{'De antwoorden voor dit vraagtype ['+props.page.question_type+'] zijn niet (meer) bechikbaar.'}</Text></View>;


   switch(props.page.question_type)
   {
      case 'question-ab': QuestionView = <QuestionAB {...props} showTip={_showTip} setAnswers={setAnswersContainer} questions={questions} given_answers={givenAnswers} />;
      break;
      case 'question-abc': QuestionView = <QuestionABC {...props} showTip={_showTip} setAnswers={setAnswersContainer} questions={questions} given_answers={givenAnswers} />;
      break;
      case 'question-open': QuestionView = <QuestionOpen {...props} showTip={_showTip} setAnswers={setAnswersContainer} questions={questions} given_answers={givenAnswers} />;
      break;
      case 'question-location': QuestionView = <QuestionLocation {...props} showTip={_showTip} setAnswers={setAnswersContainer} questions={questions} given_answers={givenAnswers} />;
      break;
      case 'range-0-100': QuestionView = <QuestionRange {...props} showTip={_showTip} setAnswers={setAnswersContainer} questions={questions} given_answers={givenAnswers} />;
      break;
      case 'swipe-ab': QuestionView = <QuestionSwipe {...props} showTip={_showTip} setAnswers={setAnswersContainer} questions={questions} given_answers={givenAnswers} />;
      break;
   }

   const excerpt = props.page.post_excerpt !== '' ? nl2br(props.page.post_excerpt) : props.page.post_content.substring(0, 250);
   let read_more: string = props.page.post_content;
   if (excerpt === read_more) read_more = '';

   return (
      <View className={'page'}>
         <View style={{paddingTop:rem(3)}}>
            <Container>
               <Row className={'justify-content-center'}>
                  <Col className={'col-2 col-md-1'}>
                        <IconButtonShadow animate={true} name={'Number-'+props.chapter} size={rem(4)} iconColor={'var(--color-white'} color={'var(--color-green)'} shadow={'var(--color-purple-dark)'} containerStyle={{alignSelf:'center',marginBottom:rem(3)}}/>
                  </Col>
                  <Col className={'col-xl-9'}>
                     <View>
                        <h3>{props.page.post_title}</h3>
                        <div>{parsePostContent({content:excerpt, firstname:props.firstname, goTo:props.goTo, index:props.index})}</div>
                        {read_more !==''?<ButtonReadMore onPress={()=>_showReadMore({...props, read_more:props.page.post_content})} style={{marginTop:rem(2)}}/>:null}
                     </View>
                  </Col>
               </Row>
            </Container>
            {QuestionView}
            <Container>
               {props.page.add_media?<Row style={{paddingTop:rem(3)}}>
                  <Col className={'view text-center'}>
                     <View style={{flexDirection:'row',alignSelf:'center',justifyContent:'center'}}>
                        {photos.map((photo: string, index: number) => (
                           <View key={index} style={{maxWidth:rem(6),maxHeight:rem(6),minWidth:rem(6),minHeight:rem(6),margin:rem(.5),overflow:'hidden'}}>
                              <img src={photo} style={{width:'100%',height:'100%',objectFit:'cover'}} />
                           </View>
                        ))}
                        {uploads?<IconButton name={'Number-'+uploads} size={rem(2)} color={'var(--color-purple)'} iconColor={'var(--color-white)'} containerStyle={{position:'relative',top:rem(1), left:rem(5.5)}}/>:null}
                        <IconButtonShadow animate={true} onPress={_addMedia} name={'Photo'} iconSize={rem(4)} size={rem(4.5)} iconColor={'var(--color-purple-dark'} color={'var(--color-green)'} shadow={'var(--color-purple-dark)'} containerStyle={{alignSelf:'center',maxWidth:rem(4.5),minHeight:rem(7), maxHeight:rem(7),marginTop:rem(1)}}/>
                     </View>
                     <Text style={{alignSelf:'center',fontWeight:'bold',fontSize:rem(1.2)}}>Je kunt ook foto's toevoegen</Text>
                  </Col>
               </Row>:null}
            </Container>
         </View>
   </View>
   );
}

export default React.memo(AppQuestion);

